import React from "react";
import styled from "styled-components";

import Badge from "@8x8/oxygen-badge";
import Tabs, { Tab } from "@8x8/oxygen-tabs";

export const StyledTabs = styled(Tabs)`
  margin: 0 0 16px;
  overflow: visible;
`;

export const StyledTab = styled(Tab)`
  overflow: visible;
`;

export const BadgedTab = (props) => {
  const {
    title,
    count,
    hideBadge = false,
    badgeColor,
    badgeTextColor,
    ...other
  } = props;
  return (
    <StyledTab {...other} key={title} color="light">
      {!hideBadge && <Badge position={"top-end"}>{count}</Badge>}
      <h6>{title}</h6>
    </StyledTab>
  );
};
